/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_InternalInputs */



/**
* | output |
* | --- |
* | "Something went wrong. Please try again." |
*
* @param {Err_InternalInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_internal = /** @type {((inputs?: Err_InternalInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_InternalInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Une erreur est survenue. Veuillez réessayer.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Algo salió mal. Por favor, inténtelo de nuevo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Algo deu errado. Por favor, tente novamente.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Qualcosa è andato storto. Per favore, riprova.")
	return /** @type {LocalizedString} */ ("Something went wrong. Please try again.")
});